<template>
  <OverlayPanel :show="show" label="Keyboard shortcuts" max-width="480px" @close="$emit('close')">
    <div class="shortcuts-header">
      <h5 class="mb-0">Keyboard Shortcuts</h5>
    </div>
    <div class="shortcuts-body">
      <div v-for="group in groups" :key="group.name" class="shortcuts-group">
        <div class="shortcuts-group-title text-secondary">{{ group.name }}</div>
        <div v-for="shortcut in group.shortcuts" :key="shortcut.id" class="shortcut-row">
          <span>{{ shortcut.description }}</span>
          <span class="shortcut-keys">
            <kbd v-for="(key, i) in keysOf(shortcut)" :key="i">{{ key }}</kbd>
          </span>
        </div>
      </div>
    </div>
  </OverlayPanel>
</template>

<script>
import OverlayPanel from "@/components/Overlay/OverlayPanel";
import {shortcutKeys} from "@/components/Shortcuts/shortcuts";

/**
 * Lists the available shortcuts, by group, in the order they're defined
 */
export default {
  name: 'ShortcutsOverlay',
  components: {OverlayPanel},
  props: {
    show: Boolean,
    shortcuts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    groups() {
      const groups = [];
      this.shortcuts
          .filter(shortcut => shortcut.available !== false)
          .forEach(shortcut => {
            let group = groups.find(item => item.name === shortcut.group);
            if (!group) {
              group = {name: shortcut.group, shortcuts: []};
              groups.push(group);
            }
            group.shortcuts.push(shortcut);
          });
      return groups;
    },
  },
  methods: {
    keysOf(shortcut) {
      return shortcutKeys(shortcut);
    },
  },
}
</script>

<style scoped>
.shortcuts-header {
  padding: 14px 16px 10px;
  border-bottom: 1px solid #e5e5e5;
}

.shortcuts-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px 0 10px;
}

.shortcuts-group-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  padding: 10px 16px 4px;
}

.shortcut-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px;
}

.shortcut-keys kbd {
  display: inline-block;
  min-width: 1.6em;
  margin-left: 4px;
  padding: 2px 6px;
  text-align: center;
  font-family: inherit;
  font-size: 0.85rem;
  color: #2c3e50;
  background-color: #f4f5f7;
  border: 1px solid #d0d4d9;
  border-bottom-width: 2px;
  border-radius: 4px;
  box-shadow: none;
}
</style>
